<template>
  <div class="pa-4 overflow-y-auto position-relative max-height-calc" id="scroll-target">
    <div v-scroll:#scroll-target="onScroll">
      <h4 class="pb-4 primaryColor" id="Introduction">Introduction</h4>
      <div class="fsize14 my-3">
        <span v-if="$store.state.brokerName == 'Aliceblue'">Aliceblue ANT</span> <span v-else>Zebu</span> APIs are Rest
        based web services that are build on top of KAMBALA to connect their Risk and Order Management
        System. The provided APIs acts as a wrapper to simplify the complex nature of the original API. <span
          v-if="$store.state.brokerName == 'Aliceblue'">Aliceblue ANT</span> <span v-else>Zebu</span> APIs provides an
        easy way to place orders, view order book, watch positions and view funds and balances.
        <span v-if="$store.state.brokerName == 'Aliceblue'">Aliceblue ANT</span> <span v-else>Zebu</span> APIs are built
        as a complete REST based platform and all input and output parameters are based on JSON unless stated otherwise.
        The service calls are platform independent and the examples given are Javascript based (AJAX) calls.
      </div>

      <div class="fsize14 my-3">
        The following diagram depicts the API authentication flow. After receiving the encryption key, user has to
        generate SHA-256 encrypted key to get User Session ID. To achieve this, the user has to encrypt the combination
        of User ID, API key and Encryption Key. Sending this to the API will provide a valid Session ID. Use the session
        ID in authorization header for all further API calls. If there are any issues found, like unauthorized access or
        invalid session, user can re-generate session id by using the same set of process described above.
      </div>
      <div class="fsize14 my-3">
        Each API call is structured as below
      </div>

      <ul class="fsize14 my-3">
        <li>URL to be called</li>
        <li>Input Parameters with example JSON set</li>
        <li>Response from server with all possible keys</li>
        <li>Error message</li>
        <li>Sample JS programs (Optional)</li>
      </ul>

      <section ref="Base URL">
        <h4 class="py-4 primaryColor">Base URL</h4>
        <div class="fsize14 my-3">The BASE URL is the common url used as prefix for all API call.</div>
        <div class="fsize14 my-3">
         
          <div class="fsize14 my-3 methodUrl Blue"><span
              class="px-2 methodName">Base URL </span><span
              class="pathUrl px-2">https://ant.aliceblueonline.com/rest/AliceBlueAPIService/api/
</span></div>
        </div>
      </section>
      <section ref="Generate API Key">
        <h4 class="py-4 primaryColor">Generate API Key</h4>
        <ul class="fsize14 my-3">
          <li>Login to the <span v-if="$store.state.brokerName == 'Aliceblue'">Aliceblue ANT</span> <span
              v-else>Zebu</span> web application.</li>
          <li>Navigate to APPS --> API key. Users can generate API key via the below button.</li>
          <li>Users will be asked to accept the 'Terms and Conditions'.</li>
          <li>After accepting the 'Terms and Conditions', the generated API key will be sent to the User's registered mail.</li>
          <li>For authentication and authorization work flow, use that API key.</li>
        </ul>
      </section>

      <section ref="API Overflow">
        <h4 class="py-4 primaryColor">API Overflow</h4>
        <div class="fsize14 my-3">
          The following diagram depicts the API authentication flow. After receiving the encryption key, user has to
          generate SHA-256 encrypted key to get User Session ID. To achieve this,
          the user has to encrypt the combination of User iD, API key and Encryption Key. Sending this to the API will
          provide a valid Session ID. Use the session ID in authorization header for all further API calls. If there are
          any issues found, like unauthorized access or invalid session, user can re-generate session id by using the
          same set of process described above.
        </div>
        <div class="d-flex justify-center ma-4">
          <img src="../assets/Flowchart-2.0.png" class="resp_img max_width_60" alt="flowchart" />
        </div>
      </section>

      <section>
        <h2 class="py-4 primaryColor">Authorization</h2>
        <div class="fsize14 my-3">
          Every request except "authentication" should be appended with Authorization header having Bearer token as
          below
        </div>
        <!-- <div class="fsize14 baseURLBlock font-weight-bold">
        Authorization: Bearer userId userSessionId
      </div> -->
        <div class="fsize14 my-3 methodUrl Blue"><span class="px-2 methodName">Authorization </span><span
            class="pathUrl px-2">{{ `"Bearer" userId userSessionId` }}</span></div>
        <div>
          <table class="app-table">
            <tbody>
              <tr>
                <td>Bearer</td>
                <td>Constant text. Adding this depends on the platform from which the user is going to make the call
                </td>
                
              </tr>
              <tr>
                <td>userId</td>
                <td>User ID used for login</td>
              </tr>
              <tr>
                <td>userSessionId</td>
                <td>User Session ID which will be received upon successful API authentication
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
      <div v-if="scrolled" class="pa-4 d-flex justify-end" style="position:sticky;right:0;bottom:0;z-index:9;opacity:1">
        <v-img @click="$store.dispatch('scrollToTop', 'Introduction')" class="cursor" max-height="50" max-width="50"
          :src="require('../assets/scrollTop.png')"></v-img>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data: () => ({}),

  computed: {
    ...mapGetters({
      activeTab: "getActiveTab",
      scrolled: "getScrolled",
    }),
  },

  watch: {
    activeTab(val) {
      this.gotoSection(val);
    },
  },

  mounted() {
    this.gotoSection(this.$store.getters.getActiveTab);
  },

  methods: {

    closePopup(){
       newWebWindow.close();
    },

    gotoSection(refName) {
      var element = this.$refs[refName];
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    },
    onScroll(e) {
      var offsetTop = e.target.scrollTop;
      offsetTop > 500
        ? this.$store.commit("setScrolled", true)
        : this.$store.commit("setScrolled", false);
    },

  }
};
</script>

<style>




</style>